const Logo = ({ variant = 'white', height = 28, className = '' }) => {
  // Sélection du logo selon la variante (white pour fond sombre, black pour fond clair)
  const logoSrc = variant === 'white' 
    ? '/images/logo-white.svg' 
    : '/images/logo-black.svg';

  return (
    <img 
      src={logoSrc}
      alt="FOMOW - Agence IA"
      className={`object-contain ${className}`}
      style={{ height: `${height}px`, width: 'auto', maxWidth: '100%' }}
    />
  );
};

export default Logo;
